RivalIQ.apps.Alerts.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.Empty = Marionette.ItemView.extend({
        className: 'x-empty',
        attributes: {
            style: 'padding: 17px 0 17px 8px;'
        },
        template: '#eventsEmptyTemplate'
    });

});
